// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IScheduledContributionUpdateDto
 */
export interface IScheduledContributionUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof IScheduledContributionUpdateDto
     */
    calendar_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IScheduledContributionUpdateDto
     */
    tax_type?: IScheduledContributionUpdateDtoTaxTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IScheduledContributionUpdateDtoTaxTypeEnum {
    PRE_TAX = 'PRE_TAX',
    POST_TAX = 'POST_TAX'
}


/**
 * Check if a given object implements the IScheduledContributionUpdateDto interface.
 */
export function instanceOfIScheduledContributionUpdateDto(value: object): value is IScheduledContributionUpdateDto {
    return true;
}

export function IScheduledContributionUpdateDtoFromJSON(json: any): IScheduledContributionUpdateDto {
    return IScheduledContributionUpdateDtoFromJSONTyped(json, false);
}

export function IScheduledContributionUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IScheduledContributionUpdateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'calendar_id': json['calendar_id'] == null ? undefined : json['calendar_id'],
        'tax_type': json['tax_type'] == null ? undefined : json['tax_type'],
    };
}

export function IScheduledContributionUpdateDtoToJSON(json: any): IScheduledContributionUpdateDto {
    return IScheduledContributionUpdateDtoToJSONTyped(json, false);
}

export function IScheduledContributionUpdateDtoToJSONTyped(value?: IScheduledContributionUpdateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'calendar_id': value['calendar_id'],
        'tax_type': value['tax_type'],
    };
}

